import './App.css';
import HomePage from './components/HomePage';
import PresPage from './components/PresPage';
import TecPage from './components/TecPage';
import TestPage from './components/TestPage';
import AvisPage from './components/AvisPage';
import ContactPage from './components/ContactPage';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <HomePage />
      <PresPage />
      <TecPage />
      <TestPage />
      <AvisPage />
      <ContactPage />
      <Footer />
    </>
  );
}

export default App;
